import { z } from 'zod';

import { storedObjectSchema } from '../../../utils';
import { sectionBaseSchema } from '../base';

/**
 * A zero row is a bare canvas: its widgets are positioned absolutely inside the
 * columns, so the row itself carries no layout knobs at all. `props` is kept —
 * empty rather than absent — so every subtype has the same shape.
 */
export const sectionZeroDataSchema = z.object({});

export const sectionZeroSchema = sectionBaseSchema.extend({
    entitySubType: z.literal('zero'),
    props: storedObjectSchema(sectionZeroDataSchema),
    version: z.literal(0),
});

export const sectionZeroV0Schema = sectionZeroSchema;
export type SectionZeroV0 = z.infer<typeof sectionZeroV0Schema>;
